import Immutable from 'immutable';

import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_BANK,
  CLEAR_BANKS,
  FLAG_BANK_ACTIVITY,
  FLAG_GETTING_BANKS,
  GET_BANK,
  GET_BANKS,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_BANKS:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_BANKS:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_BANKS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_BANK_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_BANK:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_BANK:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
